import * as React from "react";
const Google = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M21.806 10.042H21V10h-9v4h5.651A5.998 5.998 0 0 1 6 12a6 6 0 0 1 6-6c1.53 0 2.921.577 3.98 1.52l2.83-2.83A9.95 9.95 0 0 0 12 2C6.478 2 2 6.478 2 12s4.478 10 10 10 10-4.477 10-10c0-.67-.069-1.325-.195-1.959"
            fill="#FBC02D"
        />
        <path
            d="m3.153 7.346 3.286 2.409A6 6 0 0 1 12 6c1.53 0 2.921.577 3.98 1.52l2.83-2.83A9.95 9.95 0 0 0 12 2a9.99 9.99 0 0 0-8.847 5.346"
            fill="#E53935"
        />
        <path
            d="M12 22c2.583 0 4.93-.988 6.704-2.596l-3.094-2.619A5.96 5.96 0 0 1 12 18a6 6 0 0 1-5.641-3.973L3.098 16.54C4.753 19.778 8.114 22 12 22"
            fill="#4CAF50"
        />
        <path
            d="M21.806 10.042 21.797 10H12v4h5.651a6 6 0 0 1-2.043 2.785h.002l3.095 2.619C18.485 19.602 22 17 22 12c0-.67-.069-1.325-.195-1.959"
            fill="#1565C0"
        />
    </svg>
);
export default Google;
